import FormHandler from "./ahx-wcpl-ajax-form.js";

export default class DeleteListHandler extends FormHandler {
    constructor(formElement) {
        super(formElement);

        //this.listsTable = document.getElementById("product_lists");
        this.listIdElement = this.formElement?.querySelector("[name='list_id'");
        this.modalDiv = document.getElementById("delete_list_modal");

        this.modalDiv?.addEventListener("show.bs.modal", (event) => {
            if (event.relatedTarget.closest(".row")) {
                this.listId =
                    event.relatedTarget.closest(".row").dataset.listId;
                this.listIdElement.value = this.listId;
                //this.rowId = event.relatedTarget.closest(".row").rowIndex;

                //console.log(event.relatedTarget.closest(".row"));
                this.row = event.relatedTarget?.closest(".row");
            }
        });
    }

    async submitForm(event) {
        try {
            let response = await super.submitForm(event);

            window.location.href =
                window.location.origin + "/my-lists-recent-orders/";
            //this.row.remove();
            //this.listsTable.deleteRow(this.rowId);
        } catch (error) {}
    }
}
